import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Loading from 'vue-loading-overlay'
import { VueMaskDirective } from 'v-mask'

window.axios = require('axios');
import BootstrapVue from 'bootstrap-vue'

Vue.config.productionTip = false
window.axios.defaults.baseURL = process.env.VUE_APP_API_URL
const user = JSON.parse(localStorage.getItem('user'));
if (user) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
}
import Swal from "sweetalert2";
window.axios.interceptors.response.use(null, error => {
    if (error.response.status === 400) {
        Swal.fire({
            icon: 'error',
            title: error.response.data.error.message
        });
        return Promise.reject(error);
    }
    if (!error.response || error.response.status !== 401) {
        return Promise.reject(error);
    }
    const request = error.config;
    if (request.data) {
        let data = JSON.parse(request.data);
        if (data && data.grant_type) {
            return Promise.reject(error);
        }
    }
    return store.dispatch('refresh')
        .then(() => {
            return new Promise((resolve) => {
                request.headers['Authorization'] = 'Bearer ' + store.state.user.access_token;
                resolve(window.axios(request))
            })
        })
        .catch(() => {
            router.push({name: 'login'});
            return Promise.reject(error)
        });
});
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.isLoggedIn) {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        } else {
            next()
        }
    } else {
        next()
    }
})
Vue.use(BootstrapVue);
Vue.use(Loading);
Vue.directive('mask', VueMaskDirective);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
